<template>
  <div>
    <div class="filter_projects">
      <div class="row justify-content-between align-items-center text-start">
        <div class="col-12 col-sm-6 col-lg-3">
          <label>{{ $t('choose-city') }}</label>
          <v-select :items="cities"
                    :item-text="(sec) => sec.name"
                    :item-value="(sec) => sec.id"
                    v-model="filter.citiesVal"
                    filled :label="$t('filterProject.city')" prepend-inner-slot
                    no-data-text="لا يوجد بيانات">
          </v-select>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <label>{{ $t('choose-category') }}</label>
          <v-select :items="categories"
                    :item-text="(sec) => sec.name"
                    :item-value="(sec) => sec.id"
                    v-model="filter.categoriesVal"
                    filled :label="$t('filterProject.category')" prepend-inner-slot
                    no-data-text="لا يوجد بيانات">
          </v-select>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <label>{{ $t('choose-date2') }}</label>
          <v-menu :close-on-content-click="true" :nudge-right="0" transition="scale-transition"
                  offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="filter.dateVal" :placeholder="$t('choose-date2')"
                            readonly filled v-bind="attrs"
                            v-on="on" style="border: none;">
                <template #prepend-inner>
                  <v-icon color="#4D4D4D" style="margin-inline-end: 10px;">mdi-calendar</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker :locale="lang" v-model="filter.dateVal"
                           :min="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
            ></v-date-picker>
          </v-menu>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <button class="__search_project w-100" :loading="loading" @click="search">
            {{ $t("search-now") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "filter-space",
  data: () => ({
    lang: localStorage.getItem('lang') || 'ar',
    cities: [],
    categories: [],
    filter: {
      citiesVal: [],
      categoriesVal: [],
      dateVal: '',
    },
    loading: false,
  }),
  created() {
    // fetch cities
    axios.get("cities", {})
        .then(({data}) => {
          this.cities = data.data;
        });
    axios.get("categories", {})
        .then(({data}) => {
          this.categories = data.data;
        });
  },
  methods: {
    search() {
      this.$router.push({
        name: 'studios',
        query: {
          cityId: this.filter.citiesVal,
          category_id: this.filter.categoriesVal,
          add_date: this.filter.dateVal
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.filter_projects {
  margin: 0 24px 100px 0;
  background: #FFF;
  opacity: 1;
  padding: 20px 16px;
  width: 80%;
  border-radius: 8px;
  border: 1px solid #DBDBDB;
  box-shadow: 0 4.691px 18.763px 0 rgba(0, 0, 0, 0.06);

  .row label {
    font-size: 16px;
    margin-bottom: 0;
    color: #727272;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  @media (max-width: 1263px) {
    width: 100%;
    padding: 16px;
    margin: 0;
    border-radius: 8px;

    .row label {
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.__search_project {
  background: #1E1E1E 0 0 no-repeat padding-box;
  opacity: 1;
  color: #F4F4F4;
  height: 52px;
  padding: 8px 24px;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(13, 13, 18, 0.06);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 155%; /* 24.8px */
}

select {
  font-weight: 300;
}
</style>
<style>
.filter_projects .theme--light.v-text-field > .v-input__control > .v-input__slot {
  padding: 0 !important;
}

.filter_projects .theme--light.v-input input::placeholder, .theme--light.v-input textarea::placeholder {
  color: rgba(0, 0, 0, .87);
}

.filter_projects .theme--light.v-input .mdi-calendar::before {
  content: none;
}

.filter_projects .v-text-field .v-input__prepend-inner {
  display: none;
}

.filter_projects .v-text-field .v-label {
  transform-origin: top right !important;
  margin: 0 !important;
}

.filter_projects .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}

.filter_projects .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #F0F0F0;
}
</style>
